import { render, staticRenderFns } from "./pointsManager.vue?vue&type=template&id=12569af0&scoped=true"
import script from "./pointsManager.vue?vue&type=script&lang=js"
export * from "./pointsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12569af0",
  null
  
)

export default component.exports